/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const CreateAssignmentCourseDataParser = 
/* #__PURE__ */ parsers.object([['name', codecString]]);
export class CreateAssignmentCourseData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return CreateAssignmentCourseDataParser.decode(input).map(res => new CreateAssignmentCourseData(res));
    }
    static unsafeDecode(input) {
        return CreateAssignmentCourseData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CreateAssignmentCourseDataParser.encode(data);
    }
    static schema() {
        return CreateAssignmentCourseDataParser.schema();
    }
}
